angular.module('gym.access_control').controller('AccessControlOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "AccessControl", "GTMService", "planData", "FreeTrialRemindMessageText", function($scope, $rootScope, $state, $window, AccessControl, GTMService, planData, FreeTrialRemindMessageText) {
  var billingPageUrl;
  $scope.planData = planData;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'access_control';
  });
  GTMService.trackPage('Access Control Toggle');
  $scope.optInBrivo = function() {
    $scope.isLoading = true;
    GTMService.trackPage('Access Control Toggle', 'Let\'s get started');
    return AccessControl.doPOST({}, 'settings/opt_in').then(function() {
      var url;
      url = $state.href('gym.access_control.settings');
      return $window.open(url, '_self');
    });
  };
  $scope.optInInnerTelligence = function() {
    $scope.isLoading = true;
    GTMService.trackPage('Access Control Toggle', 'Let\'s get started');
    return AccessControl.doPOST({}, 'settings/innertelligence_opt_in').then(function() {
      return $scope.innerTelligenceRequested = true;
    });
  };
  billingPageUrl = $state.href('gym.subscription.tab', {
    tab: 'subscriptions'
  });
  $scope.getRemindMessageText = FreeTrialRemindMessageText.get('Established', billingPageUrl);
  $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
  return $scope.isPayor = window.currentUser.account_owner;
}]);
